import { useCallback } from 'react';
import { useSearchStore } from '../stores/search-store.js';
import { updateBarClause } from '../lib/query-builder.js';

/**
 * Hook that writes a Scryfall clause into the search bar.
 * Used by advanced panel fields and quick filters to keep the bar in sync.
 */
export function useBarClause() {
  const setUserInput = useSearchStore((s) => s.setUserInput);

  const writeClause = useCallback(
    (prefix: string, value: string | null) => {
      const currentBar = useSearchStore.getState().userInput;
      const newBar = updateBarClause(currentBar, prefix, value);
      setUserInput(newBar);
    },
    [setUserInput],
  );

  return { writeClause };
}
